import Axios from "axios";
import { serialize } from "constants/utils";
import { useCustomError } from "hooks/accessTokenExpire";
import { useEffect, useState } from "react";
import { GET_LEADERBOARD } from "services/apiService";

export const useGetLeaderboard = () => {
  const { handleError } = useCustomError();
  const [leaderboard, setLeaderboard] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const getLeaderboard = async (source: any) => {
    try {
      setIsLoading(true);
      const res = await GET_LEADERBOARD(
        serialize({
          limit: 20,
          offset: (currentPage - 1) * 20,
        }),
        source
      );
      if (res.status === 200) {
        setLeaderboard(res.data?.list);
        setTotalEntries(res.data?.total);
      }
    } catch (error: any) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const CancelToken = Axios.CancelToken;
    const source = CancelToken.source();

    getLeaderboard(source);

    return () => {
      source.cancel("Request canceled due to component unmounting");
    };
  }, [currentPage]);

  return {
    leaderboard,
    setCurrentPage,
    totalEntries,
    currentPage,
    isLoading,
  };
};
